import { formatDateISO, now } from '@/common/utils/date';
import { endOfYear, set, startOfYear } from 'date-fns';

export function getYearFilter(year: number | undefined) {
  return {
    from: formatDateISO(startOfYear(set(now(), { year }))),
    to: formatDateISO(endOfYear(set(now(), { year }))),
  };
}

export function getYearsOptions() {
  const options = [];
  let currentYear = now().getFullYear();
  while (currentYear >= 2020) {
    options.push(currentYear--);
  }
  return options;
}
